import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { AuthorizationEnum } from '../../../../enums/authorization-enum';
import { UserDto } from '../../../../dtos/user-dto';

@Component({
  selector: 'delivery-principal',
  templateUrl: './delivery-principal.component.html',
  styleUrls: ['./delivery-principal.component.scss']
})
export class DeliveryPrincipalComponent implements OnInit {

  public authorizationType: AuthorizationEnum;
  public authorizationEnum = AuthorizationEnum;
  @Output() notIterate = new EventEmitter<boolean>();

  ngOnInit(): void {
    let userStorage = localStorage.getItem('currentUser');
    if (userStorage) {
      let user: UserDto = JSON.parse(userStorage);
      if (user) {
        this.authorizationType = user.auth;
      } else {
        this.notIterateF();
      }
    } else {
      this.notIterateF();
    }

    // this.autorizationType = 2; //Este se cargará como parámetro según el usuario elegido o se obtendrá de la variable de sesión
  }

  notIterateF() {
    this.notIterate.emit(true);
  }

}
